import { ReactNode, MouseEvent } from "react";
import classNames from "classnames";

interface ButtonProps {
  children: ReactNode;
  variant?: "primary" | "secondary" | "tertiary";
  size?: "sm" | "md" | "lg" | "full-half";
  type?: "button" | "submit" | "reset";
  href?: string;
  className?: string;
  disabled?: boolean;
  onClick?: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
}

const Button = ({
  size = "lg",
  variant,
  children,
  type = "button",
  href,
  onClick,
  disabled,
  className,
}: ButtonProps) => {
  const Component = href ? "a" : "button";

  return (
    <Component
      href={href}
      type={!href ? type : undefined} 
      onClick={onClick}
      className={classNames(
        `inline-flex items-center justify-center text-center h-[40px] px-5 py-2 gap-2 rounded-md font-bold text-xs md:text-sm ${className}`,
        {
          "w-full": size === "lg",
          "w-[75%]": size === "md",
          "w-[50%]": size === "sm",
          "w-full md:w-[50%]": size === "full-half",
          "text-[#fff] bg-[#4338CA] hover:opacity-75 disabled:cursor-not-allowed disabled:opacity-75":
            variant === "primary",
          "text-[#4E4E4E] border border-[#9D9898]": variant === "secondary",
          "text-[##E11D48] bg-[#FFF1F2] border border-[#E11D48]": variant === "tertiary",
        }
      )}
      disabled={disabled}
    >
      {children}
    </Component>
  );
};

export default Button;
